import styled from '@emotion/styled';

export const MegaMenuSidebarWrapper = styled.aside`
  width: 240px;
  height: 100%;
  border-right: 1px solid #ebecf0;
`;

export const MegaMenuSidebarMenuList = styled.ul`
  width: 240px;
  height: 100%;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  list-style: none;
  margin: 0;
  padding: 0;
  gap: 4px;
`;
